/**
 * Ресурси, які створюються **лише з картки батька**.
 *
 * Третій випадок поруч із двома, які вже розрізняє `accessFn`:
 *
 *   - ресурс без екрана (немає ключа в `ResourceCorrespondenceConfig`);
 *   - ресурс без редаговних полів (`CheckResourceCreateFormTask`);
 *   - **ресурс із повноцінною формою, якої однаково не досить**.
 *
 * Приклад: дочірній запис, який бек приймає лише з батьком у потрібному стані,
 * а вибору батька у формі немає — і бути не повинно, бо дочірній запис бере
 * дані саме з нього. Заводять такий запис із картки батька; реєстр лише
 * показує.
 *
 * ⚠️ Перелік вичерпний і має лишатися коротким: кожен рядок тут — це кнопка,
 * якої користувач не побачить. Додавати сюди ресурс можна, лише якщо в нього
 * справді є інший спосіб створення.
 *
 * Контакт клієнта — саме такий: бек приймає його лише з клієнтом
 * (`client` — лише в групі створення, `SPEC-008` §5.1), а вибору клієнта у
 * формі немає. Заводять контакт кнопкою «Додати контакт» на вкладці
 * «Контакти» картки клієнта (`CrmContactsTab`).
 *
 * Договір і документ клієнта — так само: клієнт задається лише при створенні,
 * заводять їх кнопками вкладок «Договори» (`CrmContractsTab`) і «Друковані
 * форми» (`CrmDocumentsTab`) картки клієнта.
 *
 * Діти перевізника — так само (`SPEC-010` §3.4): перевізник задається лише
 * при створенні, заводять їх кнопками вкладок картки перевізника.
 */
const CREATED_FROM_PARENT: string[] = [
    'Crm.ClientContact',
    'Crm.ClientContract',
    'Crm.ClientDocument',
    'Crm.CarrierContact',
    'Crm.CarrierContract',
    'Crm.CarrierDocument',
    // Діти заявки (`SPEC-021` §8.7) — лише з її картки
    'Transportation.ApplicationPayment',
    'Transportation.ApplicationDocument',
    // «Рейси» — та сама заявка іншою вибіркою: «Додати» там немає (легасі
    // `TripPage.jsx:35-64`), створюють на «Заявках»; «Зберегти» картки лишається
    'Transportation.Trip',
    // Цінові пропозиції (`SPEC-024` §8.1) — власник лише при створенні, заводять
    // їх кнопкою «Додати» блоку «Цінові пропозиції» картки власника
    'Transportation.RequestOffer',
    'Transportation.TenderOffer',
    'Transportation.ApplicationOffer',
]

/**
 * Чи можна створювати ресурс зі списку.
 *
 * Невизначеність трактуємо на користь поточної поведінки: немає ключа — не
 * нам вирішувати, що кнопка зайва.
 */
export const CheckResourceCreatedFromParentTask = (resourceKey?: string | null): boolean => {
    if (!resourceKey) return true

    return !CREATED_FROM_PARENT.includes(resourceKey)
}

export { CREATED_FROM_PARENT }
